import type { CSSProperties } from 'react'

export function minWidthQuery(minPx: number): string {
  return `(min-width: ${minPx}px)`
}

export function resolveVisibleCount(slideCount: number, breakpointVisible: number): number {
  return Math.max(1, Math.min(slideCount, breakpointVisible))
}

export function visibleTrackStart(activeIndex: number, count: number, visibleCount: number): number {
  if (count <= visibleCount) return 0
  const maxStart = count - visibleCount
  if (activeIndex <= 0) return 0
  if (activeIndex > maxStart) return maxStart
  return activeIndex
}

export function isTrackSlotVisible(index: number, startIndex: number, visibleCount: number): boolean {
  return index >= startIndex && index < startIndex + visibleCount
}

export function testimonialTrackVars(start: number, visibleCount: number): CSSProperties {
  return {
    '--track-start': String(start),
    '--testimonial-visible': String(visibleCount),
  } as CSSProperties
}
